<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="title"
    :items="classes"
    item-value="id"
    @change="onChange"
    return-object
    v-on:input="$emit('input', $event)"
    auto-select-first
    :loading="loading"
    clearable
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import { Class, Teaching } from '@/plugins/api'
import { get } from 'lodash'

export default {
  data: () => ({
    classes: [],
    loading: false
  }),
  props: {
    filter: Object,
    defaultClasses: Array,
    changeClass: {
      type: Boolean,
      default: false
    },
    currentClass: null
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds', 'profile', 'role'])
  },
  created() {
    this.classes = this.defaultClasses || []
    this.fetchClass()
  },
  methods: {
    async fetchClass() {
      this.loading = true
      const params = {
        ...this.filter,
        status: 'running'
      }

      if (this.role.type === 'teacher') {
        if (this.$route.path.includes('marks-input')) {
          // lop giang day
          if (this.profile.id) {
            const teachingParams = {
              teacher: this.profile.id,
              _limit: -1
            }
            const teachings = await Teaching.fetch(teachingParams)
            const teachingClassIds = [...new Set(teachings.map(t => t.class && t.class.id))]

            params['id_in'] = teachingClassIds
          }
        } else if (this.ownClassIds) {
          // lop chu nhiem
          params['id_in'] = this.ownClassIds
        }

        if (params['id_in'] && params['id_in'].length) this.classes = await Class.fetch(params)
      } else {
        this.classes = await Class.getSimpleClasses(params)
      }

      if (this.changeClass && this.currentClass) {
        let classes = this.classes.filter(c => get(c.grade, 'id') === this.currentClass.grade)
        classes = this.classes.filter(c => c.id !== this.currentClass.id)
        this.classes = classes
      }
      this.loading = false
    },
    onChange(data) {
      this.$emit('change', data)
    }
  },
  watch: {
    filter(filters) {
      this.fetchClass()
    },
    currentClass() {
      this.fetchClass()
    }
  }
}
</script>
